import { FLOATS_PER_VERT, MAX_VERTS } from "./create-pipeline";
import type { TimelineVertex } from "./vertex-primitives";

export function packTimelineVertices(
  verts: TimelineVertex[],
  pixelRatio: number,
): { data: Float32Array; vertexCount: number } {
  const capped = verts.length > MAX_VERTS ? verts.slice(0, MAX_VERTS) : verts;
  const data = new Float32Array(capped.length * FLOATS_PER_VERT);
  for (let i = 0; i < capped.length; i++) {
    const v = capped[i];
    const o = i * FLOATS_PER_VERT;
    data[o] = v.x * pixelRatio;
    data[o + 1] = v.y * pixelRatio;
    data[o + 2] = v.r;
    data[o + 3] = v.g;
    data[o + 4] = v.b;
    data[o + 5] = v.a;
  }
  return { data, vertexCount: capped.length };
}
